export default __webpack_public_path__ + "static/xland-9666650348586b1e81eb4819228a7b3f.jpg";